export default __webpack_public_path__ + "static/media/chip-ic.ff3fe9fb.svg";